import styled from "styled-components";

export const PressListTable = styled.table`
  width: 100%;
  background-color: ${({ theme }) => theme.color.neural.gray00};
  margin-top: 2.4rem;
  min-width: 140rem;
`;
